/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Verify_ConfirmingInputs */

const en_onboarding_verify_confirming = /** @type {(inputs: Onboarding_Verify_ConfirmingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifying...`)
};

const de_onboarding_verify_confirming = /** @type {(inputs: Onboarding_Verify_ConfirmingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird bestätigt...`)
};

const fr_onboarding_verify_confirming = /** @type {(inputs: Onboarding_Verify_ConfirmingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vérification en cours...`)
};

const es_onboarding_verify_confirming = /** @type {(inputs: Onboarding_Verify_ConfirmingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verificando...`)
};

const it_onboarding_verify_confirming = /** @type {(inputs: Onboarding_Verify_ConfirmingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifica...`)
};

const nl_onboarding_verify_confirming = /** @type {(inputs: Onboarding_Verify_ConfirmingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifiëren...`)
};

const pl_onboarding_verify_confirming = /** @type {(inputs: Onboarding_Verify_ConfirmingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weryfikacja...`)
};

const fi_onboarding_verify_confirming = /** @type {(inputs: Onboarding_Verify_ConfirmingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vahvistetaan...`)
};

const da_onboarding_verify_confirming = /** @type {(inputs: Onboarding_Verify_ConfirmingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bekræfter...`)
};

const sv_onboarding_verify_confirming = /** @type {(inputs: Onboarding_Verify_ConfirmingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifierar...`)
};

/**
* | output |
* | --- |
* | "Verifying..." |
*
* @param {Onboarding_Verify_ConfirmingInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const onboarding_verify_confirming = /** @type {((inputs?: Onboarding_Verify_ConfirmingInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Verify_ConfirmingInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_onboarding_verify_confirming(inputs)
	if (locale === "fr") return fr_onboarding_verify_confirming(inputs)
	if (locale === "es") return es_onboarding_verify_confirming(inputs)
	if (locale === "it") return it_onboarding_verify_confirming(inputs)
	if (locale === "nl") return nl_onboarding_verify_confirming(inputs)
	if (locale === "pl") return pl_onboarding_verify_confirming(inputs)
	if (locale === "fi") return fi_onboarding_verify_confirming(inputs)
	if (locale === "da") return da_onboarding_verify_confirming(inputs)
	if (locale === "sv") return sv_onboarding_verify_confirming(inputs)
	return en_onboarding_verify_confirming(inputs)
});